// Stub file to replace Next.js polyfills for modern browsers
// This eliminates 12KB of unnecessary polyfills for:
// - Array.prototype.at, flat, flatMap
// - Object.fromEntries, hasOwn
// - String.prototype.trimStart, trimEnd

// Export empty object to satisfy module requirements
module.exports = {};
